// --- Timeline Player Constants ---

export const SNAP_THRESHOLD_PX = 10;
export const TRACK_HEADER_WIDTH = 160;
export const TRANSFORM_SNAP_THRESHOLD = 10;
export const TRACK_HEIGHT_WITH_MARGIN = 64;
export const PREVIEW_RESOLUTION = { width: 1280, height: 720 };
